<template>
  <div>
    <breadcrumb></breadcrumb>
    <con-title>联系我们</con-title>
    <div class="con w">
      <div class="contact">
        <div class="contact-con">
          <img src="../../assets/contact_tel.png" alt="" />
          <div>
            <p>联系方式</p>
            <span>13914490574</span>
          </div>
        </div>
        <div class="contact-con">
          <img src="../../assets/contact_email.png" alt="" />
          <div>
            <p>邮箱</p>
            <span>wx@tosunk.cn</span>
          </div>
        </div>
        <div class="contact-con">
          <img src="../../assets/contact_address.png" alt="" />
          <div>
            <p>地址</p>
            <span>南京市栖霞区燕子矶街道和燕路371号东南大学国家大学科技园科创楼B503室</span>
          </div>
        </div>
      </div>
      <div class="map">
<!--        <baidu-map></baidu-map>-->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  created() {},
  methods: {}
}
</script>

<style lang="scss" scoped>
.contact {
  display: flex;
  justify-content: space-between;
  padding: 20px 0;
  .contact-con {
    display: flex;
    img {
      width: 62px;
      height: 62px;
      margin-right: 15px;
      border-radius: 50%;
      border: 1px solid #ccc;
    }
    div {
      p {
        line-height: 2;
      }
      span {
        line-height: 2;
      }
    }
  }
}
.map {
  margin: 30px 0 40px;
  width: 100%;
 // border: #ccc solid 1px;
}
</style>
